import posthog from 'posthog-js';

import { env } from '@/common/env/env';
import { initializeSentry } from '@/sentry/initialize-sentry';

export const initializeMonitoring = () => {
  if (window.location.host.includes('127.0.0.1') || window.location.host.includes('localhost')) {
    return;
  }

  if (env.VITE_POSTHOG_KEY && env.VITE_POSTHOG_HOST) {
    posthog.init(env.VITE_POSTHOG_KEY, {
      api_host: env.VITE_POSTHOG_HOST,
      persistence: 'sessionStorage',
      person_profiles: 'identified_only',
      loaded: ph => {
        ph.register_for_session({ environment: env.VITE_ENVIRONMENT_NAME });
      },
    });

    const originalCapture = posthog.capture;
    posthog.capture = (eventName, properties = {}, options) => {
      const propertiesWithEnv = {
        ...properties,
        environment: env.VITE_ENVIRONMENT_NAME,
      };

      return originalCapture.call(posthog, eventName, propertiesWithEnv, options);
    };
  }

  // Sentry config lives in @/sentry (CODEOWNERS-gated).
  initializeSentry();
};
